import React, {useState} from 'react'
import './css/Login.css'
import {auth,data} from './firebase';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MailOutlineSharpIcon from '@material-ui/icons/MailOutlineSharp';
import PhoneIcon from '@material-ui/icons/Phone';
import { useHistory } from 'react-router-dom';
function X() {
    var log=document.getElementById('login');    
    var app=document.getElementById('app');  
    log.style.display="none";
    app.style.pointerEvents="all"
}
function Login() {
    const history =useHistory();
    const [email,setema]= useState('');
    const [pass,setpass]= useState('');
    const [Prénom,setPrénom]= useState('');
    const [Téléphone,setTéléphone]= useState('');
    const [city,setcity]= useState('');
    const [emailtorec,setemailtorec]= useState('');
    const enter=e=>{
        e.preventDefault();
        auth.signInWithEmailAndPassword(email,pass).then((auth)=>{
            if(auth){
                var log=document.getElementById('login');  
                var app=document.getElementById('app'); 
                app.style.pointerEvents="all";
                log.style.display="none";
                history.push('/')
            }
        }).catch(error => alert(error.message))
    }

    const PasswordReset=e=>{
        e.preventDefault();
        auth.sendPasswordResetEmail(emailtorec).then((auth)=>{
            if(auth){
                console.log("kkk")
            }
        }).catch(error => alert(error.message))
        
    }
    const sinup=e=>{
        const db = data;
        e.preventDefault();
        auth.createUserWithEmailAndPassword(email,pass).then((auth)=>{
            if(auth){
                var log=document.getElementById('login');  
                var app=document.getElementById('app'); 
                app.style.pointerEvents="all";
                log.style.display="none";
                console.log(auth.user.uid)
                db.collection("Users").doc(auth.user.uid).set({email: email,paddword:pass,Prénom:Prénom,Téléphone:Téléphone,city:city})
                history.push('/')
            }
        }).catch(error => alert(error.message))
        
    }
    function backto1() {
        var logi= document.getElementById("logi");
        logi.style.display="block"
        var rec = document.getElementById("rec");
        rec.style.display="none"
        var log=document.getElementById('login');    
        var app=document.getElementById('app');  
        log.style.display="none";
        app.style.pointerEvents="all"
    }
    function RECpass() {
        var logi= document.getElementById("logi");
        logi.style.display="none"
        var rec = document.getElementById("rec");
        rec.style.display="block"
    }
    function INSC() {
        var logi= document.getElementById("logi");
        var signup= document.getElementById("signup");
        var log=document.getElementById('login');    
        logi.style.display="none"
        signup.style.display="block"
        log.className="backs sinUP"

    }
    function LOG() {
        var logi= document.getElementById("logi");
        var signup= document.getElementById("signup");
        var log=document.getElementById('login');    
        signup.style.display="none";
        logi.style.display="block"
        log.className="backs"
    }
    return (
        <div className="backs" style={{display:"none"}} id="login">
            <div className="BOXss" id="logi">
                <p className="top">Connexion</p>
                <CloseIcon onClick={X} className="close"/>
                <div className="button">
                    <button onClick={LOG}>Mon compte</button>
                    <button onClick={INSC}>S'inscrire</button>
                </div>
                <form>
                    <div>
                        <MailOutlineIcon className="icon"/>
                        <label for="email1">Email</label>
                        <input type="email" id="email1" name="email" placeholder="example@domaine.com" value={email} onChange={e=> setema(e.target.value)}/>
                    </div>
                    <div>
                        <LockOutlinedIcon className="icon"/>
                        <label for="password">Mot de passe</label>
                        <input type="password" id="password" name="password" placeholder="******" value={pass} onChange={e=> setpass(e.target.value)}/>
                    </div>
                    
                    <input type="submit" value="Se connecter" onClick={enter}/>
                </form>
                <a onClick={RECpass} style={{cursor:"pointer"}}>Mot de passe oublié?</a>
                <p>Pas encore inscrit? <span onClick={INSC} style={{cursor:"pointer"}}>S'inscrire gratuitement.</span></p>
                <div className="line"></div>
            </div>


            <div className="BOXss" id="rec" style={{height:"33rem",display:"none"}}>
                <p className="top" style={{fontSize:"2rem",margin:"0rem auto 0",width:"25rem"}}>Vous n'arrivez pas à accéder à votre compte ?</p>
                <p style={{fontSize:"1.4rem"}}>Indiquez votre adresse e-mail, nous allons vous aider !</p>
                <CloseIcon onClick={X,backto1} className="close"/>
                <form>
                    <div style={{margin:".5rem 0"}}>
                        <MailOutlineIcon className="icon"/>
                        <label for="email1">Email</label>
                        <input type="email" id="email1" name="email" placeholder="example@domaine.com" value={emailtorec} onChange={e=> setemailtorec(e.target.value)}/>
                    </div>
                    
                    <input type="submit" value="Envoyer"style={{margin:"2rem 0 0"}} onClick={PasswordReset}/>
                </form>
                <div className="line"></div>
            </div>


            



        <div className="BOXss" id="signup" style={{display:"none"}}>
            <p className="top">Connexion</p>
            <CloseIcon onClick={X} className="close"/>
            <div className="button">
                <button onClick={LOG}>Mon compte</button>
                <button onClick={INSC}>S'inscrire</button>
            </div>
            <form>
                <div>
                    <AccountCircleIcon className="icon"/>
                    <label for="Prénom">Prénom</label>
                    <input type="text" id="Prénom" name="Prénom" placeholder="Prénom" value={Prénom} onChange={e=> setPrénom(e.target.value)}/>
                </div>
                <div>
                    <PhoneIcon className="icon"/>
                    <label for="Téléphone">Téléphone</label>
                    <input type="number" id="Téléphone" name="Téléphone" placeholder="Téléphone" value={Téléphone} onChange={e=> setTéléphone(e.target.value)}/>
                </div>
                <div>
                    <label for="email">Vilee</label>
                    <ExpandMoreIcon className="icon i2"/>
                    <select name="city" id="city" className="ss" value={city} onChange={e=> setcity(e.target.value)}>
                        <option value="3" selected="">Tout le Maroc</option>
                        <option value="Casablanca" > Casablanca</option>
                        <option value="Casablanca"> Grand Casablanca</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}}value="0" disabled="disabled">-- AUTRES VILLES --</option>
                        <option id="searcharea_expanded_fisrt_option" value="Ain Harrouda"> Ain Harrouda </option>
                        <option value="Bouskoura"> Bouskoura </option>
                        <option value="Mediouna"> Mediouna </option>
                        <option value="Mohammedia"> Mohammedia </option>
                        <option value="Nouaceur"> Nouaceur </option>
                        <option value="Tamaris"> Tamaris </option>
                        <option value="El Majjatia Ouled Taleb"> El Majjatia Ouled Taleb </option>
                        <option value="Lahraouyine"> Lahraouyine </option>
                        <option value="Sidi Hajjaj Oued Hassar"> Sidi Hajjaj Oued Hassar </option>
                        <option value="Tit Mellil"> Tit Mellil </option>
                        <option value="Dar Bouazza"> Dar Bouazza </option>
                        <option value="Errahma"> Errahma </option>
                        <option value="Lamkansa"> Lamkansa </option>
                        <option value="Oulad Salah"> Oulad Salah </option>
                        <option value="Béni Yakhlef"> Béni Yakhlef </option>
                        <option value="Chellalate"> Chellalate </option>
                        <option value="Sidi Moussa Ben Ali"> Sidi Moussa Ben Ali </option>
                        <option value="Sidi Moussa El Majdoub"> Sidi Moussa El Majdoub </option>
                    </select>
                </div>
                <div>
                    <MailOutlineIcon className="icon"/>
                    <label for="email">Email</label>
                    <input type="email" id="email" name="email" placeholder="example@domaine.com" value={email} onChange={e=> setema(e.target.value)}/>
                </div>
                <div>
                    <LockOutlinedIcon className="icon"/>
                    <label for="password1">Mot de passe</label>
                    <input type="password" id="password1" name="password" placeholder="******" value={pass} onChange={e=> setpass(e.target.value)}/>
                </div>
                
                <input type="submit" value="Se connecter" onClick={sinup}/>
            </form>
        </div>
        </div>
    )
}

export default Login
